/**
 * API клиент для загрузки шаблонов фильтров
 */

import { dataParser } from "src/common/dataParser";
import { mdmLoader } from "src/common/mdmLoader";
import { rest } from "src/common/rest";
import { RtLoaderFn } from "src/components/ReactiveTable/RtLoader";

import {
  ZFilterTemplate,
  zFilterTemplate,
  ZFilterTemplateCreate,
} from "../types";

type FilterOwnerType = "catalog" | "classifier";

const parseResp = (response: { data: unknown }, url: string): ZFilterTemplate =>
  dataParser(() => zFilterTemplate.parse(response.data), url);

const filterUrl = {
  classifier: (id: string) => `/api/core/classifiers/${id}/filters`,
  catalog: (id: string) => `/api/core/catalogs/${id}/filters`,
} as const;

const getFilterUrl = (type: FilterOwnerType, id: string): string =>
  filterUrl[type](id);

const createTemplatesLoader = (
  type: FilterOwnerType,
  id: string,
): RtLoaderFn<ZFilterTemplate, {}> =>
  mdmLoader(zFilterTemplate, getFilterUrl(type, id));

const createTemplateAction =
  (type: FilterOwnerType, id: string) =>
  async (data: ZFilterTemplateCreate): Promise<ZFilterTemplate> => {
    const url = getFilterUrl(type, id);
    const response = await rest.post(url, data);
    return parseResp(response, url);
  };

const updateTemplateAction =
  (type: FilterOwnerType, id: string) =>
  async (data: ZFilterTemplateCreate): Promise<ZFilterTemplate> => {
    const url = getFilterUrl(type, id);
    const response = await rest.put(url, data);
    return parseResp(response, url);
  };

const deleteTemplateAction =
  (type: FilterOwnerType, id: string) => (filterId: string) =>
    rest.delete(`${getFilterUrl(type, id)}/${filterId}`);

// classifier
export const classQueryBuilderTemplatesLoader = (
  classifierId: string,
): RtLoaderFn<ZFilterTemplate, {}> =>
  createTemplatesLoader("classifier", classifierId);

export const createClassQueryBuilderTemplates = (classifierId: string) =>
  createTemplateAction("classifier", classifierId);

export const updateClassQueryBuilderTemplates = (classifierId: string) =>
  updateTemplateAction("classifier", classifierId);

export const deleteClassQueryBuilderTemplate = (classifierId: string) =>
  deleteTemplateAction("classifier", classifierId);

// catalog
export const catalogQueryBuilderTemplatesLoader = (
  catalogId: string,
): RtLoaderFn<ZFilterTemplate, {}> =>
  createTemplatesLoader("catalog", catalogId);

export const createCatalogQueryBuilderTemplates = (catalogId: string) =>
  createTemplateAction("catalog", catalogId);

export const updateCatalogQueryBuilderTemplates = (catalogId: string) =>
  updateTemplateAction("catalog", catalogId);

export const deleteCatalogQueryBuilderTemplate = (catalogId: string) =>
  deleteTemplateAction("catalog", catalogId);
